import { ElementType } from 'react';
import { TextProps } from '@msc-b2c/interfaces/types';
import { sanitize, SanitizeConfig as Config } from '@msc-b2c/shared-utils';
import './text.module.scss';

export const Text = ({ id, text, visible = true, styleOption = '', tagHtml = 'p' }: TextProps) => {
  const TextComponent: ElementType = tagHtml;
  const config: Config = { ADD_ATTR: ['target'] };

  return (
    text && (
      <div
        id={id}
        className={`${styleOption} ${!visible ? '-not-visible' : ''}`}
      >
        <div className="cmp-text">
          <TextComponent
            dangerouslySetInnerHTML={{ __html: sanitize(text, config) }}
          ></TextComponent>
        </div>
      </div>
    )
  );
};
